import { api } from "@tc/ui";
export const isIOS = () => /iPhone|iPad|iPod/.test(navigator.userAgent) || (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
export const fromHomeScreen = () => window.matchMedia?.("(display-mode: standalone)").matches || navigator.standalone === true;
export async function pushState() {
    const can = "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
    if (isIOS() && (!fromHomeScreen() || !can))
        return "needs-home-screen";
    if (!can)
        return "unsupported";
    if (Notification.permission === "denied")
        return "blocked";
    const sub = await (await navigator.serviceWorker.getRegistration("/"))?.pushManager.getSubscription().catch(() => null);
    return sub ? "on" : "off";
}
/** What each state means, for My settings. */
export const PUSH_WORDS = {
    on: "On for this device.",
    off: "Off on this device.",
    blocked: "Notifications are blocked for Nozl in this browser. Allow them in the browser's settings for this site (the padlock or ⓘ by the address), then come back here.",
    "needs-home-screen": "On iPhone and iPad, notifications work once Nozl is on your Home Screen: tap Share, then Add to Home Screen, then open Nozl from the new icon and turn them on there.",
    unsupported: "This browser can't receive notifications. Try Chrome, Edge, Firefox or Safari on a recent phone or computer.",
};
const toKey = (b64) => {
    const pad = "=".repeat((4 - (b64.length % 4)) % 4);
    const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
    return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};
/** Ask the browser, subscribe, and tell the server. Returns the subscription's endpoint. */
export async function turnOnPush(pushKey) {
    const st = await pushState();
    if (st === "needs-home-screen" || st === "unsupported" || st === "blocked")
        throw new Error(PUSH_WORDS[st]);
    if ((await Notification.requestPermission()) !== "granted")
        throw new Error(PUSH_WORDS.blocked);
    const reg = await navigator.serviceWorker.register("/sw.js");
    await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(pushKey) });
    await api("/api/me/push", { method: "POST", body: sub.toJSON() });
    return sub.endpoint;
}
/** A device that's subscribed in the browser: make sure the server still has it (it may have been removed). */
export async function resyncPush() {
    const sub = await (await navigator.serviceWorker?.getRegistration("/"))?.pushManager.getSubscription().catch(() => null);
    if (sub)
        await api("/api/me/push", { method: "POST", body: sub.toJSON() }).catch(() => undefined);
}
